import type { DomainMapper } from '../types';

// TODO: Backend team should create a dedicated applicationId for corporate domains.
// Currently reusing GB's applicationId (1161 stage / 1163 prod) to get translations
// from /applications/configuration. This also returns ecom data (filters, products)
// which we don't need — the dedicated applicationId should only return translations.
const corporateSe: DomainMapper = {
  countryCode: 'corporate-se',
  currency: 'SEK',
  domain: 'kahrs-preview.iveo.store',
  environment: 'preview',
  flagUrl: '/flags/SE.svg',
  languagePrimary: false,
  locale: 'sv',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  sitemapUrl: 'https://kahrs-api.test/storage/sitemaps/sitemap-uk.xml',
  storyblokBasePath: 'sv-se',
  url: 'https://kahrs-preview.iveo.store/sv-se',
  applicationId: 1155, //  reusing SE
  subFolder: true,
  googleSiteVerification: '_khK6fTW4MrMqgixPOHH37F9BD7VJNkk3JXdFUMZthA',
  bodyClass: 'corpSite',

  features: {
    fastOrder: false,
    backorders: false,
    cartSettings: false,
    nonEcomSite: true,
    cisionLanguage: 'sv',
  },
} as DomainMapper;

export default corporateSe;
